var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Arrow left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.9999 11.5C19.9999 11.2238 19.7761 11 19.4999 11H7.82992L13.0651 5.76476C13.2609 5.56901 13.2603 5.25146 13.0639 5.0564L12.3535 4.35101C12.158 4.15693 11.8424 4.15748 11.6476 4.35226L4.35348 11.6464C4.15822 11.8417 4.15822 12.1582 4.35348 12.3535L11.6464 19.6464C11.8416 19.8417 12.1582 19.8417 12.3535 19.6464L13.0567 18.9432C13.2518 18.748 13.252 18.4317 13.057 18.2364L7.82992 13H19.4999C19.7761 13 19.9999 12.7761 19.9999 12.5V11.5Z",
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.f550893cf6339dae1b5681d56b0bd962.svg";
export { ForwardRef as ReactComponent };